import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabla-opt',
  templateUrl: './tabla-opt.component.html',
  styleUrls: ['./tabla-opt.component.css']
})
export class TablaOptComponent implements OnInit {
  displayedColumns: string[] = ['no'];
  simbolos: any;

  constructor() {this.simbolos = localStorage.getItem('opt'); }

  ngOnInit(): void {
    this.simbolos = JSON.parse(this.simbolos);
  }

}
